import { Link, useNavigate } from "react-router-dom";
import { LogOut, LayoutDashboard, Shield } from "lucide-react";
import Logo from "@/components/Logo";
import { useAuth } from "@/auth";

export default function DashNav() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-40 glass border-b border-[#26262F]">
      <div className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" aria-label="Card Cartel home">
          <Logo />
        </Link>
        <div className="flex items-center gap-2 sm:gap-4">
          <span className="text-xs text-zinc-500 hidden md:block mono">{user?.email}</span>
          <Link
            to="/dashboard"
            data-testid="nav-dashboard-link"
            className="flex items-center gap-1.5 text-xs text-zinc-300 hover:text-[#E6C665] transition-colors px-3 py-2"
          >
            <LayoutDashboard className="w-3.5 h-3.5" /> Dashboard
          </Link>
          {user?.is_admin && (
            <Link
              to="/admin"
              data-testid="nav-admin-link"
              className="flex items-center gap-1.5 text-xs text-zinc-300 hover:text-[#E6C665] transition-colors px-3 py-2"
            >
              <Shield className="w-3.5 h-3.5" /> Admin
            </Link>
          )}
          <button
            data-testid="nav-logout-btn"
            onClick={async () => {
              await logout();
              navigate("/");
            }}
            className="btn-ghost-gold flex items-center gap-1.5 text-xs px-3 py-2 rounded-full"
          >
            <LogOut className="w-3.5 h-3.5" /> Logout
          </button>
        </div>
      </div>
    </header>
  );
}
